import { FunctionComponent } from 'react';

import componentSwitch from 'utils/componentSwitch';

import DonationSuccessLayout from './donationSuccessLayout';
import DonationSuccessLayoutOverlay from './overlayVariant/donationSuccessLayout';
import { DonationSuccessLayoutProps } from './types';

export default componentSwitch(DonationSuccessLayout, DonationSuccessLayoutOverlay) as FunctionComponent<DonationSuccessLayoutProps>;
